/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <div v-if="isCompanyManager" class="store_login_unit_manage_menu">企業管理者画面</div>
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div class="company_tbl_unit wd976 tbl_ht_none tbl_bg_blue" v-show="!isInitLoading">

            <div v-if="auth == 1" class="admin_menu_top_unit">
                <div class="company_buttan_unit">
                    <div class="company__kanri_box">
                        <ul><li>
                            <router-link class="company_buttan_unit top_tit" :to="{ name: 'manageCommpanyBrandAdd'} ">新規登録</router-link>
                        </li></ul>
                    </div>
                </div>
            </div>

            <table class="company_list_font">
                <tbody>
                <tr class="text-center">
                    <th class="wd170 border_bottom_none" v-for="(value,key) in columns" :key="key" @click="sortBy(key)">
                        {{value}}
                        <img class="triangle" v-if="sortOrders[key] > 0" src="../assets/img/UnderTriangleWhite.png" width="15px" height="13px" alt="UnderTriangle">
                        <img class="triangle" v-if="sortOrders[key] <= 0" src="../assets/img/UpTriangleWhite.png" width="15px" height="13px" alt="UpTriangle">
                    </th>
                    <th class="wd170" rowspan="2">登録日付</th>
                    <th class="wd170" rowspan="2">更新日付</th>
                    <th v-if="auth == 2 || auth == 5" class="wd150" rowspan="2">編集</th>
                    <th v-else-if="auth == 1 || auth == 3" class="wd150" rowspan="2">詳細/削除</th>
                </tr>
                <tr>
                    <th class="border_top_none"><input class="wd150" type="text" v-model="searchWord" placeholder="キーワード検索"> </th>
                    <th class="border_top_none"><input class="wd150" type="text" v-model="searchWord2" placeholder="キーワード検索"></th>
                    <th class="border_top_none"><input class="wd150" type="text" v-model="searchWord3" placeholder="キーワード検索"></th>
                </tr>
                <tr v-for="brandList in filteredDatas" :key="brandList.brandId">
                    <td class="text_white_space" v-for="(value,key) in columns" :key="key">
                        {{brandList[key]}}
                    </td>
                    <td class="text_white_space">{{brandList.createDatetime}}</td>
                    <td class="text_white_space">{{brandList.updateDatetime}}</td>
                    <td v-if="auth == 2 || auth == 5" class="company_buttan_unit staff_kanri_box text_white_space">
                        <ul class="ul_tbl_buttan">
                            <li>
                                <router-link class="company_buttan_unit"
                                    @click.native="setBrandId(brandList.id)"
                                    :to="{ name: 'manageCommpanyBrandEdit', params: { brandId:brandList.brandId } } ">編集</router-link>
                            </li>
                        </ul>
                    </td>
                    <td v-else-if="auth == 1" class="company_buttan_unit staff_kanri_box text_white_space">
                        <ul class="ul_tbl_buttan">
                            <li>
                                <router-link class="company_buttan_unit"
                                    @click.native="setBrandId(brandList.id)"
                                    :to="{ name: 'manageCommpanyBrandDetail', params: { id:brandList.id, brandId:brandList.brandId }} ">詳細</router-link>
                            </li>
                        </ul>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
export default {
    name: 'CommpanyBraindList',
    components: {
        PulseLoader
    },
    data: function () {
        var columns = {
            brandId :"企業コード",
            companyName: "企業名",
            brandName:"ブランド名"
        };
        var sortOrders = {};
        Object.keys(columns).forEach(function (key) {
            sortOrders[key] = 1
        });
        return {
            isInitLoading:true,
            brandId: '',
            auth:'',
            columns:columns,
            sortKey:'',
            sortOrders:sortOrders,
            searchWord:'',
            searchWord2:'',
            searchWord3:'',
            brand: []
        }
    },
    created: function(){
        this.calc();
        this.clearBrandId();
    },
    methods:{
        async calc(){

            //ブランドIDを取得
            this.brandId = this.$store.getters['manager/manager'].brandId;
            //権限情報を取得
            this.auth = this.$store.getters['manager/manager'].authorityKbn;

            // 企業ブランド一覧取得API
            await this.$axios
            .get(this.$apiEndpoint + 'manage/brand', { params: { brand_id: this.brandId}})
            .then(response => (this.brand = response['data']['brand']))
            .catch((err) => {
                let error = {
                    button: {
                        path: {name: 'top', params:{brandPath: this.brandPath}}
                    }}
                if (err.customError) {
                    error = Object.assign(error, err.customError)
                }
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }).finally(()=> this.isInitLoading = false);
        },
        sortBy:function(key){
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;

        },
        setBrandId(id) {
            this.$store.dispatch('brand/setBrandId', id)
        },
        clearBrandId() {
            this.$store.dispatch('brand/clearBrandId')
        }
    },
    computed:{
        filteredDatas:function(){
            var data = this.brand;

            var sortKey = this.sortKey;
            var order = this.sortOrders[sortKey] || 1;

            if(sortKey){
                data = data.slice().sort(function(a,b){
                    a = a[sortKey];
                    b = b[sortKey];
                    return(a === b ? 0 : a > b? 1 : -1) * order;
                });
            }

            var filterWord = this.searchWord && this.searchWord.toLowerCase();
            if(filterWord){
                data = data.filter(function (row){
                    return Object.keys(row).some(function (){
                        return String(row["brandId"]).toLowerCase().indexOf(filterWord) === 0
                    })
                })
            }

            var filterWord2 = this.searchWord2 && this.searchWord2.toLowerCase();
            if(filterWord2){
                data = data.filter(function (row){
                    return Object.keys(row).some(function (){
                        return String(row["companyName"]).toLowerCase().indexOf(filterWord2) === 0
                    })
                })
            }

            var filterWord3 = this.searchWord3 && this.searchWord3.toLowerCase();
            if(filterWord3){
                data = data.filter(function (row){
                    return Object.keys(row).some(function (){
                        return String(row["brandName"]).toLowerCase().indexOf(filterWord3) === 0
                    })
                })
            }

            return data;

        },
        brandPath: function () {
            if (this.auth == this.$store.getters['manager/manager'].authorityKbn) {
                return process.env.VUE_APP_ADMIN_BRAND_PATH
            }
            return this.$store.getters['brand/path']
        },
        isCompanyManager: function () {
            return this.auth == 2
        },
    }
}
</script>